<template>
  <div id="app">
    <header class="header" @click="onClick()">
      <div class="header__logo-wrapper">
        <Logo/>
      </div>
    </header>
    <router-view/>
    <scroll-btn></scroll-btn>
  </div>
</template>


<script>
import Logo from "./assets/logo.svg";
import ScrollBtn from "./components/ScrollBtn";

export default {
  name: "App",
  components: {
    Logo,
    ScrollBtn
  },
  methods: {
    onClick(){
      this.$store.dispatch("lockApp");
      this.$SmoothScroll(0, 250, () => {
        this.$store.dispatch("restart");
        this.$store.commit("CHECKHEIGHT");
        this.$store.dispatch("unlockApp");
      });
    }
  }
};
</script>


<style lang="scss">
body {
  background-color: rgba(0, 0, 0, 1);
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  background: transparent;
  min-height: calc(100vh + 1px); // always show scrollbars
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue